import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import UTags from "ubs-framework/v2/UTags";
import UDateFormatter from "ubs-framework/v2/Udate-formatter";
import {COLOR} from "ubs-framework/v2/common/constant";
import UNoDataFound from "ubs-framework/v2/UErrorPages/UNoDataFound";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import useSocket from "../../../hooks/useSocket";
import {sendData} from "../../../../../store/actions";

const ViewRemark = ({getRemark, onClose}) => {
    const _ORG_ID = useSelector(e => e.common.orgId);
    const [list, setList] = useState([]);

    const {off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|candidate|getRemark': {
                    setList(res?.data?.getRemarks)
                    break;
                }
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        refresh();
        sendData('ats|candidate|getRemark', getRemark);
        return () => off();
    }, []);

    return (
        <UModal
            open={true}
            onClose={onClose}
            confirmationOnClose
            header={<h4>{list?.length || 0} Remarks</h4>}
            position="right"
        >
            {list?.length ? <div className="u_p-15 u_w-full u_remarks">
                    {list?.map(data => {
                        return (<div className="u_remarks-inner u_mb-10">
                            <div className="u_flex-align u_content-between u_px-15 u_py-12">
                                <div className="u_flex-align">
                                    <p className="u_one-line u_mr-15">{data?.remarkByOrg}</p>
                                    {data?.remarkByOrgId === _ORG_ID && <UTags title={`You have given`} color={COLOR.u_orange} className="u_flex-shrink u_mr-5"/>}
                                </div>
                                <span className="u_flex-shrink"><UDateFormatter date={data?.updatedAt} format={'ddd, MMMM D, YYYY'}/></span>
                            </div>

                            <h3>{data?.remarkReason}</h3>
                        </div>)
                    })}
                </div> :
                <UNoDataFound image="/images/no-any-activity.svg" message="No data to display"/>}
        </UModal>
    );
};

export default ViewRemark;
